"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ExportWorkflowTodosCsvQuery () {
        return ExportWorkflowTodosCsvQuery;
    },
    get ListWorkflowDetailTodosQuery () {
        return ListWorkflowDetailTodosQuery;
    },
    get ListWorkflowTodosQuery () {
        return ListWorkflowTodosQuery;
    },
    get ListWorkflowsQuery () {
        return ListWorkflowsQuery;
    },
    get UpdateWorkflowArchivedBody () {
        return UpdateWorkflowArchivedBody;
    },
    get WorkflowDetailTodoStatusFilterSchema () {
        return WorkflowDetailTodoStatusFilterSchema;
    },
    get WorkflowIdParams () {
        return WorkflowIdParams;
    },
    get WorkflowSortBySchema () {
        return WorkflowSortBySchema;
    },
    get WorkflowStatusFilterSchema () {
        return WorkflowStatusFilterSchema;
    },
    get WorkflowTodoSortBySchema () {
        return WorkflowTodoSortBySchema;
    },
    get WorkflowTodoStatusFilterSchema () {
        return WorkflowTodoStatusFilterSchema;
    }
});
const _zod = require("zod");
const _response = require("./response");
const WorkflowSortBySchema = _zod.z.enum([
    "start_date",
    "name"
]);
const WorkflowStatusFilterSchema = _zod.z.enum([
    "active",
    "completed",
    "overdue"
]);
const BooleanQueryParam = _zod.z.enum([
    "true",
    "false"
]).transform((value)=>value === "true");
const ListWorkflowsQuery = _zod.z.object({
    sortBy: WorkflowSortBySchema.default("start_date"),
    sortOrder: _zod.z.enum([
        "asc",
        "desc"
    ]).default("desc"),
    limit: _zod.z.coerce.number().int().min(1).max(100).default(25),
    skip: _zod.z.coerce.number().int().min(0).default(0),
    name: _zod.z.string().max(256).optional(),
    workflowName: _zod.z.string().max(256).optional(),
    subject: _zod.z.string().regex(/^[0-9a-fA-F]{24}$/).optional(),
    status: WorkflowStatusFilterSchema.optional(),
    overdueOnly: BooleanQueryParam.optional(),
    unassignedOnly: BooleanQueryParam.optional()
});
const WorkflowTodoSortBySchema = _zod.z.enum([
    "due_date",
    "action",
    "date_done"
]);
const WorkflowTodoStatusFilterSchema = _zod.z.enum(_response.WORKFLOW_TODO_STATUSES);
const ObjectIdQueryParam = _zod.z.string().regex(/^[0-9a-fA-F]{24}$/);
// Calendar date (no time component); the API treats ranges built from these as inclusive.
const DateOnlyQueryParam = _zod.z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
const ListWorkflowTodosQuery = _zod.z.object({
    sortBy: WorkflowTodoSortBySchema.default("due_date"),
    sortOrder: _zod.z.enum([
        "asc",
        "desc"
    ]).default("asc"),
    limit: _zod.z.coerce.number().int().min(1).max(100).default(25),
    skip: _zod.z.coerce.number().int().min(0).default(0),
    action: _zod.z.string().max(256).optional(),
    subject: ObjectIdQueryParam.optional(),
    actor: ObjectIdQueryParam.optional(),
    workflow: ObjectIdQueryParam.optional(),
    status: WorkflowTodoStatusFilterSchema.optional(),
    dueDateStart: DateOnlyQueryParam.optional(),
    dueDateEnd: DateOnlyQueryParam.optional(),
    completedDateStart: DateOnlyQueryParam.optional(),
    completedDateEnd: DateOnlyQueryParam.optional()
});
const ExportWorkflowTodosCsvQuery = ListWorkflowTodosQuery.omit({
    limit: true,
    skip: true,
    sortBy: true,
    sortOrder: true
});
const WorkflowIdParams = _zod.z.object({
    workflowId: ObjectIdQueryParam
});
const WorkflowDetailTodoStatusFilterSchema = _zod.z.enum(_response.WORKFLOW_DETAIL_TODO_STATUSES);
const ListWorkflowDetailTodosQuery = _zod.z.object({
    sortBy: WorkflowTodoSortBySchema.default("due_date"),
    sortOrder: _zod.z.enum([
        "asc",
        "desc"
    ]).default("asc"),
    limit: _zod.z.coerce.number().int().min(1).max(100).default(25),
    skip: _zod.z.coerce.number().int().min(0).default(0),
    action: _zod.z.string().max(256).optional(),
    actor: ObjectIdQueryParam.optional(),
    status: WorkflowDetailTodoStatusFilterSchema.optional(),
    dueDateStart: DateOnlyQueryParam.optional(),
    dueDateEnd: DateOnlyQueryParam.optional(),
    hasSignatureRequest: BooleanQueryParam.optional()
});
const UpdateWorkflowArchivedBody = _zod.z.object({
    archived: _zod.z.boolean()
});
